import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {ResourceOption} from '../../../graphql/resources.datatypes';
import {gqlResourceOption} from '../getResourceOption.api';
import {UpdateResourceOptionVars} from './updateResourceOption.api';

interface UpdateResourceOptionData {
    __typename?: string,
    updateResourceOptionCascade: ResourceOption
}

export const UPDATE_RESOURCE_OPTION_MUTATION = gql`
    mutation updateResourceOptionCascade($data: UpdateResourceOptionInput!) {
        updateResourceOptionCascade(data: $data) {
            ${gqlResourceOption}
        }
    }
`;

export const updateResourceOptionCascade = () => useMutation<UpdateResourceOptionData, UpdateResourceOptionVars>(
    UPDATE_RESOURCE_OPTION_MUTATION,
    {
        update: updateCacheByType('ResourceOption'),
    }
);

export default updateResourceOptionCascade;